import React, { useMemo } from 'react'

import { Icon, MailFilled } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import {
  arrayOf, bool, func, number, string,
} from 'prop-types'

import { iconSize } from 'Pods/LazyLoaded/AiSignInModal/constants'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

import ErrorMessage from './Components/ErrorMessage/ErrorMessage'
import Inputs from './Components/Inputs/Inputs'
import Resend from './Components/Resend/Resend'

function CodeStep({
  email,
  digits,
  hasError,
  resendSecondsLeft,
  onDigitsChange,
  onResend,
}) {
  const t = useTranslation()
  const maskedEmail = useMemo(() => email.trim(), [email])

  return (
    <div className="ai-sign-in-modal__code">
      <span className="ai-sign-in-modal__code-icon">
        <Icon svgComponent={MailFilled} size={iconSize} notSpaced />
      </span>
      <div className="ai-sign-in-modal__header-group ai-sign-in-modal__header-group--center">
        <p className="ai-sign-in-modal__title cgt-heading-300">{t('signIn.code.title')}</p>
        <p className="ai-sign-in-modal__subtitle cgt-body-md">
          {t('signIn.code.subtitlePrefix')}
          {' '}
          {maskedEmail ? (
            <span className="ai-sign-in-modal__email cgt-body-md-semibold">{maskedEmail}</span>
          ) : (
            t('signIn.code.yourEmail')
          )}
        </p>
      </div>
      <Inputs digits={digits} hasError={hasError} onDigitsChange={onDigitsChange} />
      <ErrorMessage hasError={hasError} />
      <Resend secondsLeft={resendSecondsLeft} onResend={onResend} />
    </div>
  )
}

CodeStep.propTypes = {
  email: string.isRequired,
  digits: arrayOf(string).isRequired,
  hasError: bool.isRequired,
  resendSecondsLeft: number.isRequired,
  onDigitsChange: func.isRequired,
  onResend: func.isRequired,
}

export default CodeStep
